export default __webpack_public_path__ + "static/badge-github-marketplace-47a034828e18040117fa7f5afaf19048.svg";